// Include React
var React = require("react");

var Projects = React.createClass({
    render: function(){
        return(

            <div className="col s12">
                <a name="projects"> </a>
                <div className="row">

                        <div className="col s12 m4">
                            <div className="card medium">
                                <div className="card-image waves-effect waves-block waves-light">
                                    <img className="activator" src="../assets/images/yolo.png"/>
                                </div>
                                <div className="card-content">
                                    <span className="card-title activator grey-text text-darken-4">YOLO<i className="mdi mdi-dots-vertical right"> </i></span>
                                    <p><a href="http://yolo-orlando.herokuapp.com/" target="#">Check out the live demo</a></p>
                                </div>
                                <div className="card-reveal">
                                    <span className="card-title grey-text text-darken-4">YOLO<i className="mdi mdi-close right"> </i></span>
                                    <p><strong>Role:</strong> Backend Development (team)</p>
                                    <p><strong>Description:</strong> Utilizing the Open Weather & IPinfo.io APIs. This powerful app finds your location, checks your local weather, and returns a suggested event based on that local weather data.</p>
                                    <p><a target="#" href="https://github.com/adeerjustoutside/YOLO">Check out the repo</a></p>
                                    <p><strong>Key Features: </strong>
                                        <div className="chip"><i className="mdi mdi-language-javascript"> </i>JavaScript</div>
                                        <div className="chip"><i className="mdi mdi-currency-usd"> </i>jQuery</div>
                                        <div className="chip"><i className="mdi mdi-language-html5"> </i>HTML</div>
                                        <div className="chip"><i className="mdi mdi-language-css3"> </i>CSS</div>
                                        <div className="chip"><i className="mdi mdi-web"> </i>API Consumption</div>
                                        <div className="chip"><i className="mdi mdi-bootstrap"> </i>Bootstrap</div>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col s12 m4">
                            <div className="card medium">
                                <div className="card-image waves-effect waves-block waves-light">
                                    <img className="activator" src="../assets/images/burger.png"/>
                                </div>
                                <div className="card-content">
                                    <span className="card-title activator grey-text text-darken-4">Eat-Da-Burger<i className="mdi mdi-dots-vertical right"> </i></span>
                                    <p><a href="https://server-burger.herokuapp.com/burgers" target="#">Check out the live demo</a></p>
                                </div>
                                <div className="card-reveal">
                                    <span className="card-title grey-text text-darken-4">Eat-Da-Burger<i className="mdi mdi-close right"> </i></span>
                                    <p><strong>Role:</strong> Full Stack Developer</p>
                                    <p><strong>Description:</strong> Educational exercise to showcase rendering persistent data from a MySQL database to the browser. Create, read, update, and delete (CRUD) database records from the client-side.</p>
                                    <p><a target="#" href="https://github.com/dreballo/sequelizeburger">Check out the repo</a></p>
                                    <p><strong>Key Features: </strong>
                                        <div className="chip"><i className="mdi mdi-language-javascript"> </i>JavaScript</div>
                                        <div className="chip"><i className="mdi mdi-language-html5"> </i>HTML</div>
                                        <div className="chip"><i className="mdi mdi-language-css3"> </i>CSS</div>
                                        <div className="chip"><i className="mdi mdi-nodejs"> </i>Node.js</div>
                                        <div className="chip"><i className="mdi mdi-NPM"> </i>NPM</div>
                                        <div className="chip"><i className="mdi mdi-express"> </i>Express</div>
                                        <div className="chip"><i className="mdi mdi-database"> </i>MySQL</div>
                                        <div className="chip"><i className="mdi mdi-handlebars"> </i>Handlebars</div>

                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col s12 m4">
                            <div className="card medium">
                                <div className="card-image waves-effect waves-block waves-light">
                                    <img className="activator" src="../assets/images/Stile.png"/>
                                </div>
                                <div className="card-content">
                                    <span className="card-title activator grey-text text-darken-4">Stile<i className="mdi mdi-dots-vertical right"> </i></span>
                                    <p><a href="https://young-woodland-59453.herokuapp.com/" target="#">Check out the live demo</a></p>
                                </div>
                                <div className="card-reveal">
                                    <span className="card-title grey-text text-darken-4">Stile<i className="mdi mdi-close right"> </i></span>
                                    <p><strong>Role:</strong> Full Stack Developer</p>
                                    <p><strong>Description:</strong> Concept for an app that enables you to find available stylists in your area and schedule appointments with ease.</p>
                                    <p><a target="#" href="https://github.com/dreballo/stile_lite">Check out the repo</a></p>
                                    <p><strong>Key Features: </strong>
                                        <div className="chip"><i className="mdi mdi-language-javascript"> </i>JavaScript</div>
                                        <div className="chip"><i className="mdi mdi-language-html5"> </i>HTML</div>
                                        <div className="chip"><i className="mdi mdi-language-css3"> </i>CSS</div>
                                        <div className="chip"><i className="mdi mdi-nodejs"> </i>Node.js</div>
                                        <div className="chip"><i className="mdi mdi-NPM"> </i>NPM</div>
                                        <div className="chip"><i className="mdi mdi-express"> </i>Express</div>
                                        <div className="chip"><i className="mdi mdi-database"> </i>MySQL</div>
                                        <div className="chip"><i className="mdi mdi-handlebars"> </i>Handlebars</div>

                                    </p>
                                </div>
                            </div>
                        </div>

                </div>
                <div className="row">
                    <div className="col s12 m4">
                        <div className="card medium">
                            <div className="card-image waves-effect waves-block waves-light">
                                <img className="activator" src="../assets/images/jordan.jpg"/>
                            </div>
                            <div className="card-content">
                                <span className="card-title activator grey-text text-darken-4">Michael Jordan Fan Trivia<i className="mdi mdi-dots-vertical right"> </i></span>
                                <p><a href="https://air-jordan-trivia.herokuapp.com/" target="#">Check out the live demo</a></p>
                            </div>
                            <div className="card-reveal">
                                <span className="card-title grey-text text-darken-4">Michael Jordan Fan Trivia<i className="mdi mdi-close right"> </i></span>
                                <p><strong>Role:</strong> Web Developer</p>
                                <p><strong>Description:</strong> Trivia game based on the career of the greatest basketball player of all time. Beat the clock and answer all off the questions correctly.</p>
                                <p><a target="#" href="https://github.com/Dreballo/TriviaGame">Check out the repo</a></p>
                                <p><strong>Key Features: </strong>
                                    <div className="chip"><i className="mdi mdi-language-javascript"> </i>JavaScript</div>
                                    <div className="chip"><i className="mdi mdi-language-html5"> </i>HTML</div>
                                    <div className="chip"><i className="mdi mdi-language-css3"> </i>CSS</div>


                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col s12 m4">
                        <div className="card medium">
                            <div className="card-image waves-effect waves-block waves-light">
                                <img className="activator" src="../assets/images/crystal.jpg"/>
                            </div>
                            <div className="card-content">
                                <span className="card-title activator grey-text text-darken-4">Crystal Collector<i className="mdi mdi-dots-vertical right"> </i></span>
                                <p><a href="https://crysrtal-counter.herokuapp.com/" target="#">Check out the live demo</a></p>
                            </div>
                            <div className="card-reveal">
                                <span className="card-title grey-text text-darken-4">Stile<i className="mdi mdi-close right"> </i></span>
                                <p><strong>Role:</strong> Web Developer</p>
                                <p><strong>Description:</strong>Try and reach the targeted number by selecting each crystal with a random value. Hit the target and you win, exceed the target and you lose.</p>
                                <p><a target="#" href="https://github.com/Dreballo/week-4-game">Check out the repo</a></p>
                                <p><strong>Key Features: </strong>
                                    <div className="chip"><i className="mdi mdi-language-javascript"> </i>JavaScript</div>
                                    <div className="chip"><i className="mdi mdi-language-html5"> </i>HTML</div>
                                    <div className="chip"><i className="mdi mdi-language-css3"> </i>CSS</div>

                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col s12 m4">
                        <div className="card medium">
                            <div className="card-image waves-effect waves-block waves-light">
                                <img className="activator" src="../assets/images/bamazon.png"/>
                            </div>
                            <div className="card-content">
                                <span className="card-title activator grey-text text-darken-4">Bamazon<i className="mdi mdi-dots-vertical right"> </i></span>
                                <p><a href="#modal1" target="#">Check out a video demo</a></p>

                                <div id="modal1" className="modal">
                                    <div className="modal-content center">
                                        <iframe src="https://player.vimeo.com/video/235599721" width="700" height="535" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen />
                                    </div>

                                </div>
                            </div>
                            <div className="card-reveal">
                                <span className="card-title grey-text text-darken-4">Bamazon<i className="mdi mdi-close right"> </i></span>
                                <p><strong>Role:</strong> Web Developer</p>
                                <p><strong>Description:</strong> Bamazon is a node.js application that simulates a user storefront, where users can "purchase" items, and track store inventory.</p>
                                <p><a target="#" href="https://github.com/dreballo/bamazon">Check out the repo</a></p>
                                <p><strong>Key Features: </strong>
                                    <div className="chip"><i className="mdi mdi-language-javascript"> </i>JavaScript</div>
                                    <div className="chip"><i className="mdi mdi-nodejs"> </i>Node.js</div>
                                    <div className="chip"><i className="mdi mdi-NPM"> </i>NPM</div>
                                    <div className="chip"><i className="mdi mdi-express"> </i>Express</div>
                                    <div className="chip"><i className="mdi mdi-database"> </i>MySQL</div>

                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = Projects;


// WEBPACK FOOTER //
// ./src/components/children/projects.js